<template>
  <div class="container">
    <div>
      <a-form :wrapper-col="{ span: 12 }">
        <a-form-item v-for="(input, index) in EditableInputFields" :key="index" :wrapper-col="{ span: 6 }">
          <label>{{ input.label }}:</label>
          <a-input :id="input.input_id" :value="input.value" @input="updateValue(index, $event.target.value)">
            <a-tooltip slot="suffix" :title="input.label">
              <a-icon type="info-circle" style="color: rgba(0,0,0,.45)" />
            </a-tooltip>
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" html-type="submit" @click="update_db()">Update</a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>
<script>
export default {
  name: "CrudEdit",
  data() {
    return {
      row: this.$route.params.data.row,
      api_route: this.$route.params.data.api_route,
      columns: this.$route.params.data.columns,
      id : 0,
      EditableInputFields: [],
      EditableInputFieldsIDs: []
    }
  },
  mounted() {
    if (!this.$route.params.data || Object.keys(this.$route.params.data).length === 0 || !this.$route.params.data.row || Object.keys(this.$route.params.data.row).length === 0) {
      this.$router.push('/dashboards');
    }
  },
  created() {
    for (let key in this.columns) {
      let title = this.columns[key]['title'];
      if (title === 'Actions') {
        continue
      }
      let dataIndexValue = this.columns[key]['dataIndex'];
      let row_value = this.row[dataIndexValue];
      if (dataIndexValue === 'id') {
        this.id = row_value;
      } else {
        this.EditableInputFields.push(
          {
            label: title,
            value: row_value,
            input_id: dataIndexValue + '_id'
          }
        );
        this.EditableInputFieldsIDs.push(
          dataIndexValue + '_id'
        );
      }
    }
  },

  methods: {
    updateValue(index, newValue) {
      this.EditableInputFields[index].value = newValue;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        console.log(values);
        if (!err) {
          console.log('Received values of form: ', values);
        }
      });
    },
    update_db() {
      this.arr_val = [{}];
      for (var key in this.EditableInputFieldsIDs) {
        var id = this.EditableInputFieldsIDs[key];
        var id_key = id.replace('_id', '');
        var input_value = document.getElementById(id.toString()).valueOf().value;

        this.arr_val[0][id_key] = input_value;
      }
      // var request_json = JSON.stringify(this.arr_val);
      console.log(this.arr_val);

      this.$store.dispatch(this.api_route, { id: this.id, data: this.arr_val[0] });
    }
  }
}
</script>

<style scoped></style>